import apiService from './api-service'

const prospectsService = {}

/**
 * Retrieve a prospects by it's id
 * @param  array params (optional)
 * @return prospects
 */
prospectsService.list = function (params) {
  return apiService.get(`/prospects`, { params }).then(res => res.data)
}

/**
 * Retrieve a prospects by it's id
 * @param  int id
 * @param  array params (optional)
 * @return prospects
 */
prospectsService.getById = function (id) {
  return apiService.get(`/prospects/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Update a prospects by it's id
 * @param  int id
 * @param  array params (optional)
 * @return prospects
 */
prospectsService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/prospects/${id}`, body).then(res => res.data)
}

/**
 * Create a promoters by it's id
 * @param  object body
 * @return promoters
 */
prospectsService.post = function (body) {
  return apiService.post(`/prospects`, body).then(res => res.data)
}

/**
 * Retrieve all status codes
 * @param  object params
 * @return status' list
 */
prospectsService.getStatusList = function (params) {
  return apiService.get(`/prospects/status_list`, { params }).then(res => res.data)
}

export default prospectsService



// WEBPACK FOOTER //
// ./src/services/prospects.js